const r = "Premi Tab per andare a Popover", t = {
  triggerHint: r
};
export {
  t as default,
  r as triggerHint
};
